import "./App.css";
import Book from "./components/Book";

function App() {
  return (
    <div className="App">
      <Book />
    </div>
  );
}

export default App;
